import {getInputControlMeta} from '@wix/wix-events-commons-statics'
import React, {useEffect, useState} from 'react'
import {Error} from '../../commons/error'
import {Label} from '../../commons/label'
import {Select} from '../../commons/select'
import fs from '../../fields.scss'
import {DropdownProps} from './interfaces'

export const Dropdown = ({input, control, meta: {dirty, touched, error}, t}: DropdownProps) => {
  const [selectedValue, setSelectedValue] = useState(null)

  const {options, label, mandatory} = getInputControlMeta(control)

  const onChange = (selectedOption: string) => {
    input.onChange(selectedOption)
    setSelectedValue(selectedOption)
  }

  useEffect(() => {
    if (!selectedValue && input.value) {
      onChange(input.value)
    }
  }, [])

  return (
    <div className={fs.field}>
      <Label classes={fs.customCaption} dataHook="dropdown-caption" required={mandatory} caption={label} />
      <Select options={options} value={selectedValue} ariaLabel={label} onChange={onChange} noDefaultValue={true} />
      <Error error={(dirty || touched) && error && t(error)} />
    </div>
  )
}
